<template>
  <div class="text-2xl sm:text-3xl">
    Find A Medicare Advantage Plan In 3 Simple Steps
  </div>

  <FormButtonNext> Get Started </FormButtonNext>
</template>
